import type { App } from "vue";

import { type VueQueryPluginOptions } from "@tanstack/vue-query";
import { VueQueryPlugin } from "@tanstack/vue-query";

const config: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry: 1,
        throwOnError: true,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
      },
      mutations: {
        throwOnError: true,
        retry: 0,
      },
    },
  },
};

export function useVueQuery() {
  const plugin = {
    install: (app: App) => {
      app.use(VueQueryPlugin, config);
    },
  };

  return plugin;
}
